import React from 'react';
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import DashboardEvvList from "../../components/dashboard/DashboardEvvList";

const DashboardEvvPage = () => {
    return (
        <React.Fragment>
            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <DashboardEvvList/>
                    </Grid>
                </Grid>
            </Container>

        </React.Fragment>
    );
};

export default DashboardEvvPage;